import {Filter} from '../../shared/models/filter.model';
import {Utilities} from '../../shared/utilities/utilities.model';
import {DateUtilities} from '../../shared/utilities/date-utilities.model';

export class OrdersFilter extends Filter {

	txt_search_index: string;
	cod_typ_state: string;
	txt_model: string;
	id_order: string;
	txt_plate: string;
	txt_chassis: string;
	cod_veh_type: string;
	id_typ_purchase: string;
	date_rec_ins_from: string;
	date_rec_ins_to: string;
	date_transfer_expected_from: string;
	date_transfer_expected_to: string;
	flag_fastdelivery: string;
	flag_specialsetup: string;
	flag_delivery_block: string;
	cod_delivery_class: string;
	flag_reallocated: string;

	date_delivery_confirmation_from: string;
	date_delivery_confirmation_to: string;
	val_priority: string;
	flag_priority_forced: boolean;
	txt_labels: string;

	constructor(model?: any) {
		super();
		if (model) {
			if (model.txt_search_index) {
				this.txt_search_index = model.txt_search_index;
			}
			if (model.cod_typ_state) {
				this.cod_typ_state = model.cod_typ_state;
			}
			if (model.txt_model) {
				this.txt_model = model.txt_model;
			}
			if (model.id_order) {
				this.id_order = model.id_order;
			}
			if (model.txt_plate) {
				this.txt_plate = model.txt_plate;
			}
			if (model.txt_chassis) {
				this.txt_chassis = model.txt_chassis;
			}
			if (model.cod_veh_type) {
				this.cod_veh_type = model.cod_veh_type;
			}
			if (model.id_typ_purchase) {
				this.id_typ_purchase = model.id_typ_purchase;
			}
			if (model.flag_reallocated) {
				this.flag_reallocated = model.flag_reallocated;
			}
			if (!Utilities.isVoid(model.current_flag)) {
				switch (model.current_flag) {
					case 'flag_fastdelivery':
						this.flag_fastdelivery = '1';
						this.flag_delivery_block = null;
						this.flag_specialsetup = null;
						break;
					case 'flag_specialsetup':
						this.flag_fastdelivery = null;
						this.flag_delivery_block = null;
						this.flag_specialsetup = '1';
						break;
					case 'flag_delivery_block':
						this.flag_fastdelivery = null;
						this.flag_delivery_block = '1';
						this.flag_specialsetup = null;
						break;
				}
			} else {
				this.flag_fastdelivery = null;
				this.flag_delivery_block = null;
				this.flag_specialsetup = null;
			}
			if (!Utilities.isVoid(model.date_rec_ins_from)) {
				if (typeof model.date_rec_ins_from === 'string') {
					this.date_rec_ins_from = model.date_rec_ins_from;
				} else {
					this.date_rec_ins_from = DateUtilities.getStringFromMoment(model.date_rec_ins_from, DateUtilities.onlyDate);
				}
			}
			if (!Utilities.isVoid(model.date_rec_ins_to)) {
				if (typeof model.date_rec_ins_to === 'string') {
					this.date_rec_ins_to = model.date_rec_ins_to;
				} else {
					this.date_rec_ins_to = DateUtilities.getStringFromMoment(model.date_rec_ins_to, DateUtilities.onlyDate);
				}
			}
			if (!Utilities.isVoid(model.date_transfer_expected_from)) {
				if (typeof model.date_transfer_expected_from === 'string') {
					this.date_transfer_expected_from = model.date_transfer_expected_from;
				} else {
					this.date_transfer_expected_from = DateUtilities.getStringFromMoment(model.date_transfer_expected_from, DateUtilities.onlyDate);
				}
			}
			if (!Utilities.isVoid(model.date_transfer_expected_to)) {
				if (typeof model.date_transfer_expected_to === 'string') {
					this.date_transfer_expected_to = model.date_transfer_expected_to;
				} else {
					this.date_transfer_expected_to = DateUtilities.getStringFromMoment(model.date_transfer_expected_to, DateUtilities.onlyDate);
				}
			}
			if (!Utilities.isVoid(model.date_delivery_confirmation_from)) {
				if (typeof model.date_delivery_confirmation_from === 'string') {
					this.date_delivery_confirmation_from = model.date_delivery_confirmation_from;
				} else {
					this.date_delivery_confirmation_from = DateUtilities.getStringFromMoment(model.date_delivery_confirmation_from, DateUtilities.onlyDate);
				}
			}
			if (!Utilities.isVoid(model.date_delivery_confirmation_to)) {
				if (typeof model.date_delivery_confirmation_to === 'string') {
					this.date_delivery_confirmation_to = model.date_delivery_confirmation_to;
				} else {
					this.date_delivery_confirmation_to = DateUtilities.getStringFromMoment(model.date_delivery_confirmation_to, DateUtilities.onlyDate);
				}
			}
			this.page = model.page;
			this.page_size = model.page_size;
			this.order_by = model.order_by;
			this.asc = model.asc;
			if (!Utilities.isVoid(model.cod_delivery_class)) {
				this.cod_delivery_class = model.cod_delivery_class;
			}

			if (model.val_priority) {
				this.val_priority = model.val_priority;
			}

			if (model.flag_priority_forced) {
				this.flag_priority_forced = model.flag_priority_forced;
			}

			if (model.txt_labels) {
				this.txt_labels = model.txt_labels;
			}
		}
	}

	clone(): OrdersFilter {
		return new OrdersFilter(this);
	}

	getCurrentFlag(): string | null {
		if (!Utilities.isVoid(this.flag_fastdelivery)) {
			return 'flag_fastdelivery';
		}
		if (!Utilities.isVoid(this.flag_specialsetup)) {
			return 'flag_specialsetup';
		}
		if (!Utilities.isVoid(this.flag_delivery_block)) {
			return 'flag_delivery_block';
		}
		return null;
	}

	newFilter(model?: any): OrdersFilter {
		return new OrdersFilter(model);
	}

	getFilterUrl(): string {
		let filterUrl: string = Utilities.getQuery(this);
		if (!Utilities.isVoid(this.date_rec_ins_from) && Utilities.isVoid(this.date_rec_ins_to)) {
			filterUrl += '&date_rec_ins_to=31/12/2099';
		}
		if (!Utilities.isVoid(this.date_rec_ins_to) && Utilities.isVoid(this.date_rec_ins_from)) {
			filterUrl += '&date_rec_ins_from=01/01/1900';
		}
		if (!Utilities.isVoid(this.date_transfer_expected_from) && Utilities.isVoid(this.date_transfer_expected_to)) {
			filterUrl += '&date_transfer_expected_to=31/12/2099';
		}
		if (!Utilities.isVoid(this.date_transfer_expected_to) && Utilities.isVoid(this.date_transfer_expected_from)) {
			filterUrl += '&date_transfer_expected_from=01/01/1900';
		}
		if (!Utilities.isVoid(this.date_delivery_confirmation_from) && Utilities.isVoid(this.date_delivery_confirmation_to)) {
			filterUrl += '&date_delivery_confirmation_to=31/12/2099';
		}
		if (!Utilities.isVoid(this.date_delivery_confirmation_to) && Utilities.isVoid(this.date_delivery_confirmation_from)) {
			filterUrl += '&date_delivery_confirmation_from=01/01/1900';
		}
		return filterUrl;
	}

}
